import BaseProducts from "./BaseProducts";
export default BaseProducts;
